<script>
  // import QuickSearchBar from "../QuickSearch.svelte";
  // import AutoComplete from "./Autocomplete.svelte";
  import Search from "../FindPlans/Search.svelte";

  import {
    reportCopy,
    getCopyGroup,
    currentScenario,
    currentPlanId,
  } from "../../stores/currentSelections.js";
  import { dropdownData } from "../../stores/currentSelections.js";

  export let type;
  export let placeholder = null;
  export let bg = "white";
  export let icon = null;

  $: scenarios = getCopyGroup($reportCopy, {
    section: "selections",
    subCection: "scenario",
    type: "option",
  });

  let border = bg === "white";
</script>

<div class="mb-4">
  <div class="mb-2">
    <slot />
  </div>

  {#if type === "search"}
    <Search
      items={$dropdownData}
      bind:value={$currentPlanId}
      {icon}
      {placeholder}
      labelFieldName="class_name"
      valueFieldName="equableclassid"
      keywordsFunction={(plan) =>
        `${plan.class_name} ${plan.plan_fullname} ${plan.system_name} ${plan.state}`}
    />
  {:else if type === "scenarios"}
    <select
      class="placeholder-gray-300 block text-base md:text-lg lg:text-xl font-medium text-neutral rounded-sm min-h-12 w-full whitespace-pre-wrap {border
        ? 'border border-gray-200'
        : 'border-none'} bg-{bg}"
      bind:value={$currentScenario}
    >
      <option class="whitespace-pre-wrap" value="" disabled selected>
        {placeholder}
      </option>
      {#each scenarios as option, i}
        {#if i !== 3}
          <option class="whitespace-pre-wrap" value={i + 1}>
            {option.copy}
          </option>
        {/if}
      {/each}
    </select>
  {/if}
</div>

<style>
  select option {
    white-space: pre-wrap;
  }

  .min-h-12 {
    min-height: 3rem;
  }
</style>
